<template>
    <v-app>
        <v-main>
            <div id="body">
                <v-container fluid>
                    <div class="text-center" style="font-family:Sans-serif">
                        <center>
                        <v-overlay v-model="overlay">
                            <v-progress-circular
                            indeterminate
                            :size="55"
                            :width="3">
                            </v-progress-circular>Logging in....
                        </v-overlay>
                        </center>
                    </div>
                    <v-row align="center" justify="center" style="height:90vh">
                        <v-card style="height: 500; width: 600px;" class="rounded-lg" elevation="0">
                            <v-row class="mt-1" style="box-shadow: 8px 8px 20px 1px rgba(0,0,0,.3)">

                                <!-- JAPANESE -->
                                <v-col v-if="lang == 'jap'" cols="6" class="ma-0 pa-0" style="height: 420px; position: relative; background-color: #263238 ; border-radius: 10px 0px 0px 10px;">
                                    <v-container fluid>
                                        <v-card-title class="ml-n3" style="font-size: 26px; color: white;">
                                            <!-- <img src="https://media.giphy.com/media/IcnxGGAj0ubyB2r5M6/giphy.gif" alt="iQPD System Icon" class="mr-2 mirrored-icon" style="width: 30px; height: 24px;"> -->
                                            CAD 依頼システム </v-card-title>
                                        <v-card-subtitle class="mt-n6" style="color: white; font-size: 12px;">ver 2.{{cadRequestVersion.version}}</v-card-subtitle>

                                        <v-card-text class="mt-3 mb-3" style="text-indent: 20px; text-align: justify; font-size: 13px; color: white;">
                                        <!-- "Empowering CAD Department Staff with a Performance Monitoring System, fostering Individual excellence in Quality, Productivity, and timely Delivery." -->
                                            "CAD 依頼システムは、CAD 依頼を送信するためのシステムです。このシステム
                                            は、この時間の短縮と、受付漏れ等のヒューマンエラーを無くすことを目的としています。"
                                        </v-card-text>

                                        <div class="ml-2" style="position: absolute; margin-top: 150px;">
                                            <span style="font-size: 11px; color: white;">Powered by: </span>
                                            <span style="font-size: 11px; color: #56e6a8;">Integrated HRD System Department</span>
                                        </div>
                                    </v-container>
                                    
                                    <div class="">
                                        <vue-particles
                                            color="FFFFFF"
                                            :particleOpacity="0.9"
                                            :particlesNumber="100"
                                            shapeType="circle"
                                            :particleSize="5"
                                            linesColor="#dedede"
                                            :linesWidth="1"
                                            :lineLinked="true"
                                            :lineOpacity="0.5"
                                            :linesDistance="200"
                                            :moveSpeed="3"
                                            :hoverEffect="true"
                                            hoverMode="grab"
                                            :clickEffect="false"
                                            clickMode="push"
                                        >
                                        </vue-particles>
                                    </div>
                                </v-col>

                                <!-- ENGLISH -->
                                <v-col v-else cols="6" class="ma-0 pa-0" style="height: 420px; position: relative; background-color: #263238 ; border-radius: 10px 0px 0px 10px;">
                                    <v-container fluid>
                                        <v-card-title class="ml-n3" style="font-size: 26px; color: white;">
                                            <!-- <img src="https://media.giphy.com/media/IcnxGGAj0ubyB2r5M6/giphy.gif" alt="iQPD System Icon" class="mr-2 mirrored-icon" style="width: 30px; height: 24px;"> -->
                                            CAD Request System</v-card-title>
                                        <v-card-subtitle class="mt-n6" style="color: white; font-size: 12px;">ver 2.{{cadRequestVersion.version}}</v-card-subtitle>

                                        <v-card-text class="mt-3 mb-3" style="text-indent: 20px; text-align: justify; font-size: 13px; color: white;">
                                        <!-- "Empowering CAD Department Staff with a Performance Monitoring System, fostering Individual excellence in Quality, Productivity, and timely Delivery." -->
                                            "The CAD request system is a system for sending CAD requests. This  system  aims  to  shorten  this  time  and 
                                                eliminate human errors such as missed receptions."
                                        </v-card-text>

                                        <div class="ml-2" style="position: absolute; margin-top: 170px;">
                                            <span style="font-size: 11px; color: white;">Powered by: </span>
                                            <span style="font-size: 11px; color: #56e6a8;">Integrated HRD System Department</span>
                                        </div>
                                    </v-container>
                                    
                                    <div class="">
                                        <vue-particles
                                            color="FFFFFF"
                                            :particleOpacity="0.9"
                                            :particlesNumber="100"
                                            shapeType="circle"
                                            :particleSize="5"
                                            linesColor="#dedede"
                                            :linesWidth="1"
                                            :lineLinked="true"
                                            :lineOpacity="0.5"
                                            :linesDistance="200"
                                            :moveSpeed="3"
                                            :hoverEffect="true"
                                            hoverMode="grab"
                                            :clickEffect="false"
                                            clickMode="push"
                                        >
                                        </vue-particles>
                                    </div>
                                </v-col>

                                <v-col cols="6" class="ma-0 pa-0" style="position: relative; border-radius: 0px 10px 10px 0px;">
                                    <v-toolbar flat color="transparent">
                                        <v-spacer></v-spacer>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon v-if="lang == 'jap'" @click="translate('eng')" style="cursor: pointer;" v-bind="attrs" v-on="on">mdi-translate</v-icon>
                                                <v-icon v-else @click="translate('jap')" style="cursor: pointer;" v-bind="attrs" v-on="on">mdi-translate-off</v-icon>
                                            </template>
                                            <span>Translate</span>
                                        </v-tooltip>
                                    </v-toolbar>
                                    <v-container class="mt-n9 ml-2" fluid>
                                        <!-- <v-card-title v-if="lang == 'jap'" class="ml-n4" style="font-weight: bold; font-size: 25px; color: #263238 ;">いらっしゃいませ！</v-card-title>
                                        <v-card-subtitle v-if="lang == 'jap'" class="ml-n4 mb-5" style="font-size: 12px; color: grey;">続行するにはログインしてください。</v-card-subtitle> -->
                                        <v-card-title v-if="lang == 'jap'" class="ml-n4" style="font-weight: bold; font-size: 25px; color: #263238 ;"></v-card-title>
                                        <v-card-subtitle v-if="lang == 'jap'" class="ml-n4 mb-5" style="font-size: 12px; color: grey;"><br><br></v-card-subtitle>

                                        <!-- <v-card-title v-if="lang == 'eng'" class="ml-n4" style="font-weight: bold; font-size: 25px; color: #263238 ;">Welcome!</v-card-title>
                                        <v-card-subtitle v-if="lang == 'eng'" class="ml-n4 mb-5" style="font-size: 12px; color: grey;">Please login to continue.</v-card-subtitle> -->
                                        <v-card-title v-if="lang == 'eng'" class="ml-n4" style="font-weight: bold; font-size: 25px; color: #263238 ;"></v-card-title>
                                        <v-card-subtitle v-if="lang == 'eng'" class="ml-n4 mb-5" style="font-size: 12px; color: grey;"><br><br></v-card-subtitle>
                                            <v-form id="LoginForm" ref="LoginForm" v-on:submit.prevent="handleLogin" class="mr-2">
                                                <v-text-field
                                                    type="email"
                                                    :label="emailLabel"
                                                    name="email"
                                                    v-model="employee.email"
                                                    append-icon="mdi-account-circle"
                                                    required
                                                    readonly 
                                                    autocomplete="off"
                                                    @focus="$event.target.removeAttribute('readonly');"
                                                    outlined
                                                    dense
                                                    :rules="[...rules.email, ...rules.required]"
                                                ></v-text-field>

                                                <v-text-field
                                                    v-model="employee.password"
                                                    id="hiddenPassword"
                                                    :label="passLabel"
                                                    autocomplete="off"
                                                    :type="showPassword ? 'text' : 'password' "
                                                    :append-icon="showPassword ? 'mdi-eye': 'mdi-eye-off'"
                                                    @click:append="showPassword = !showPassword"
                                                    @focus="$event.target.removeAttribute('readonly');"
                                                    required
                                                    readonly
                                                    outlined
                                                    dense
                                                    name="password"
                                                    :rules="rules.required"
                                                ></v-text-field>


                                                <v-card-actions :class="{ 'pa-3': $vuetify.breakpoint.smAndUp }">
                                                    <v-spacer></v-spacer>
                                                    <v-btn dark block  color="#263238" type="submit" :disabled="disableBtn">
                                                    <v-icon left>mdi-lock</v-icon>
                                                    {{loginLabel}}
                                                    </v-btn>
                                                </v-card-actions>
                                                <!-- <div style="width:100%;text-align:center;font-size:17px;">
                                                  <a style="text-decoration:underline;color:#263238;transition: color 0.3s;" 
                                                      onmouseover="this.style.color='#265cff'" 
                                                      onmouseout="this.style.color='#263238'"
                                                      @click="handleLogin('guest')">
                                                    Log-in as HRD Viewer
                                                  </a>
                                                </div> -->
                                                </v-form>
                                        <v-row>
                                    <!-- <v-col >
                                        <v-btn
                                            color="#263238 "
                                            class="text-none mt-10"
                                            style="font-size: 13px; width: 95%;"
                                            :loading="loading"
                                            dark
                                            @click="getUser()"
                                        >
                                            LOGIN
                                        </v-btn>
                                    </v-col> -->
                                    <!-- <v-col class="mt-5 ml-5">
                                        <v-avatar style="border:2px solid #e5e8eb;box-shadow:0px 4px 4px rgba(0, 0, 0, 0.4);" v-show="showUserImage" size="90">
                                        <v-img  class="dialog-image" aspect-ratio="3" :src="userImageUrl" ></v-img>
                                        </v-avatar>
                                    </v-col> -->
                                </v-row>
                                    </v-container>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-row>
                </v-container>
            </div>
        </v-main>
    </v-app>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import md5 from 'js-md5'
import Swal from 'sweetalert2';
export default {
    name : 'LoginPage',
    data() {
        return {
            lang: 'jap',
            overlay : false,
            showPassword: false, 
            disableBtn: false,
            loading: false,
            employee : {},
            tab : null,
            emailLabel: 'Eメール',
            passLabel: 'パスワード',
            loginLabel: 'ログイン',
        };
    },
    computed: {
      ...mapState([
        'rules',
        'loggedInUser',
        'cadRequestVersion'
      ])
    },
    async beforeCreate(){
        await this.$store.dispatch('cadRequestVer')
    },

    methods: {
      ...mapActions([
          'login',
          'saveToken',
      ]),

      translate(text){
        this.lang = text;
        if(text == 'eng'){
            this.emailLabel = 'Email';
            this.passLabel = 'Password';
            this.loginLabel = 'LOGIN';
        }else{
            this.emailLabel ='Eメール';
            this.passLabel ='パスワード';
            this.loginLabel ='ログイン';
        }
      },
      showCustomUnsupportedBrowserModal() {
        Swal.fire({
            icon: 'error',
            title: 'You are using a browser that is not supported by the system!',
            html: `Please switch to <span style="color: red;">Google Chrome</span>.`,
            customClass: {
              confirmButton: 'btn btn-danger',
            },
            buttonsStyling: false,
            confirmButtonText: '', // Empty text to hide the confirm button
            allowOutsideClick: false, // Prevent closing by clicking outside the modal
            allowEscapeKey: false, // Prevent closing with the Escape key
            showCancelButton: false, // Hide the Cancel button
            showCloseButton: false, // Hide the close (X) button
        });
      },
      
      resetForm(){
        if(this.$refs.LoginForm){
          this.$refs.LoginForm.reset();
        }

        if(this.$refs.RegisterForm){
          this.$refs.RegisterForm.reset();
        }
      },

      async _requestToken(formdata){

        formdata.append('grant_type', process.env.MIX_PASSPORT_ACCESS_CLIENT_GRANT_TYPE);
        formdata.append('client_id', process.env.MIX_PASSPORT_ACCESS_CLIENT_ID);
        formdata.append('client_secret', process.env.MIX_PASSPORT_ACCESS_CLIENT_SECRET);
        formdata.append('username', formdata.get('email'));
        formdata.set('password', md5(formdata.get('password')))

        await axios({
              method: 'POST',
              url: 'oauth/token',
              data: formdata,
              config: {
                  headers: { "Content-Type": "multipart/form-data" },
              },
            })
            .then(({ data }) => {
              this.login().then(() => {
                this.saveToken(data)
                
              })
            })
      },

      handleLogin() {
        // if(text == 'guest'){
        //   this.overlay = true;
        //   var formdata = new FormData();
        //   formdata.append('email','guest@hrd-s.com')
        //   formdata.append('password','guest')

        //   axios({
        //     method: 'POST',
        //     url: `login`,
        //     data: formdata,
        //   }).then(({data})=>{

        //     if(data.type == 'error'){
        //       alert(data.message, "error")
        //       this.disableBtn = false
        //       this.overlay = false
        //       return;
        //     }

        //     this._requestToken(formdata).then(()=> {
        //       this.overlay = false;
        //     })

        //     })
        //     .catch(err =>{
        //     this.disableBtn = false
        //     console.log(err)
        //     alert('Something went wrong!')
        //     })
        //   }else{
          // this.overlay = true;
          if(this.$refs.LoginForm.validate()){
            // this.disableBtn = true

            const myForm = document.getElementById('LoginForm');
            const formdata = new FormData(myForm)

            axios({
                method: "POST",
                url: `login`,
                data: formdata,
                config: {
                    headers: { "Content-Type": "multipart/form-data" },
                },
            })   
            .then(({data})=>{
              

              if(data.type == 'error'){
                alert(data.message, "error")
                this.disableBtn = false
                this.overlay = false
                return;
              }else{
                this.overlay = true;
              }

              this._requestToken(formdata).then(()=> {
                this.overlay = false;
              })
              
            })
            .catch(err =>{
            this.disableBtn = false
              console.log(err)
            alert('Something went wrong!')
            })
          } 
        // }
      },

      // handleRegistration(){
      //   this.disableBtn = true
      //   if(this.$refs.RegisterForm.validate()){
      //     const myForm = document.getElementById('RegisterForm');
      //     const formdata = new FormData(myForm);

      //     axios({
      //       method : "POST",
      //       url : 'register',
      //       data: formdata,
      //       config: {
      //             headers: { "Content-Type": "multipart/form-data" },
      //         },
      //     })
      //     .then(() => {
      //        this.login()
      //     })
      //     .catch(err =>{
      //       this.disableBtn = false
      //       console.log(err)
      //       alert('Something Went Wrong')
      //     })
      //   }
      // },
    },

    mounted() {
      if (!this.$store.state.isChrome || /Edg/.test(navigator.userAgent)) {
        // Show a custom Swal modal for unsupported browsers
        this.showCustomUnsupportedBrowserModal();
      }
    },
    watch: {
    },
};
</script>
<style scoped>
.mirrored-icon {
  transform: scaleX(-1);
}
.centered-input input {
  text-align: center;

}
@keyframes fadeIn {
   0% {
     opacity: 0;
     transform: translateY(20px);
   }
   100% {
     opacity: 1;
     transform: translateY(0);
   }
 }

 .fade-in-title {
   animation: fadeIn 2s ease-in-out;
   font-size: 15px;
   font-weight: italic !important;
   color: rgb(88, 91, 6) !important;
 }
 
@keyframes heartbeat {
   0% {
     transform: scale(1);
   }
   30% {
     transform: scale(1.05);
   }
   80% {
     transform: scale(1);
   }
 }
 .dialog-image {
   max-width: 100%; /* Ensure the image fits within the dialog */
   margin-right: 0px;
 }
 .custom-avatar-effect {
   animation: heartbeat 1s infinite;
 }

.elevation-custom {
   box-shadow: 0px 5px 11px rgba(0, 0, 0, 0.6); /* Adjust the rgba values for darkness */
 }
.swal-wide{
   width:250px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
   -webkit-appearance: none;
   margin: 0;
}


</style>
